import { useQuery } from '@tanstack/react-query'
import { api } from '@services/api'
import { appointmentApi } from '@services/appointment.service'
import type { Appointment, Note, PaginatedResponse } from '@/types'

/**
 * Lo que Scarlett (la recepcionista de WhatsApp) deja en el HMS y el equipo
 * revisa desde Inicio: solicitudes de cita por confirmar y notas de recepción.
 * Ambas consultas se refrescan solas para que el tablero se mueva en vivo
 * mientras la asistente conversa con los pacientes.
 */

export const isScarlettAuthor = (name?: string | null) => /scarlett|integraci[oó]n/i.test(name ?? '')

export function usePendingApprovals() {
  return useQuery({
    queryKey: ['scarlett', 'pending-approvals'],
    queryFn: async () => (await appointmentApi.getPendingApprovals(0, 50)).items,
    refetchInterval: 20_000,
  })
}

export function useRecentReceptionNotes(limit = 8) {
  return useQuery({
    queryKey: ['scarlett', 'reception-notes', limit],
    queryFn: async () => {
      const data = await api.get<PaginatedResponse<Note>>('/notes', { params: { limit, skip: 0 } })
      return [...(data.items ?? [])]
        .filter((n) => n.note_type === 'FOLLOW_UP' || n.note_type === 'OTHER')
        .sort((a, b) => b.created_at.localeCompare(a.created_at))
    },
    refetchInterval: 30_000,
  })
}

export const patientLabel = (a: Appointment) =>
  a.patient ? `${a.patient.first_name} ${a.patient.last_name}` : (a.patient_name || 'Paciente')

export const doctorLabel = (a: Appointment) =>
  a.doctor ? `Dra. ${a.doctor.first_name} ${a.doctor.last_name}` : (a.doctor_name ? `Dra. ${a.doctor_name}` : '')
